<template>
  <div
    v-if="collapsed"
    class="PasswordBox d-flex flex-column"
  >
    <b-button
      variant="secondary"
      class="PasswordBox__Button"
      squared
      @click="openPasswordBox"
    >
      {{ $t(`${$options.name}.changePassword`) }}
    </b-button>
  </div>
  <div
    v-else
    class="PasswordBox d-flex flex-column pt-3"
  >
    <div class="px-4">
      <Feedback
        v-if="feedback.show"
        :feedback="feedback"
      />
      <form @submit="handleSubmit">
        <label
          class="PasswordBox__Label"
          for="new-password"
        >
          {{ $t(`${$options.name}.newPassword`) }}
        </label>

        <b-input
          id="new-password"
          ref="password"
          v-model="password"
          :disabled="busy"
          class="PasswordBox__Input"
        />
      </form>
      <p class="PasswordBox__Instruction text-muted mt-2">
        {{ $t(`${$options.name}.instruction`) }}
      </p>
    </div>
    <b-button
      squared
      :disabled="busy"
      variant="cta"
      class="PasswordBox__Button mt-3"
      @click="handleSubmit"
    >
      {{ $t(`${$options.name}.changePassword`) }}
    </b-button>
  </div>
</template>

<script>

import Feedback from '@/components/form/Feedback.vue'

export default {
  name: 'PasswordBox',
  components: { Feedback },
  data() {
    return {
      busy: false,
      collapsed: true,

      password: '',
      feedback: {
        show: false,
        message: '',
        variant: 'danger',
      },
    }
  },
  watch: {
    busy(busy) {
      this.$emit('processing', { busy })
    },
  },
  methods: {
    openPasswordBox() {
      this.collapsed = false

      // Focus password input field
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleSubmit: async function(e) {
      e.preventDefault()

      if (this.password === '') {
        this.feedback = {
          show: true,
          message: this.$i18n.t('PasswordBox.messages.required'),
          variant: 'danger',
        }
        return
      }

      this.busy = true

      const token = await this.$auth.getTokenSilently()
      const api = await fetch('/api/userpassword', {
        method: 'POST',
        headers: {
          authorization: 'Bearer ' + token,
        },
        body: JSON.stringify({
          password: this.password,
        }),
      })

      let response = await api.json()

      if (response.message === 'success') {
        this.feedback = {
          show: true,
          message: this.$i18n.t('PasswordBox.messages.success'),
          variant: 'success',
        }

        setTimeout(this.logout, 3000)
      }
      else {
        let message = this.$i18n.t('PasswordBox.messages.general')

        if (response.message === 'PasswordStrengthError: Password is too weak') {
          message = this.$i18n.t('PasswordBox.messages.weakPassword')
        } else if (response.message === 'PasswordHistoryError: Password has previously been used') {
          message = this.$i18n.t('PasswordBox.messages.alreadyUsed')
        } else if (response.message === 'Blacklisted') {
          message = this.$i18n.t('PasswordBox.messages.blacklisted')
        } else if (response.message === 'Password is required') {
          message = this.$i18n.t('PasswordBox.messages.required')
        }

        this.feedback = {
          show: true,
          message,
          variant: 'danger',
        }
        this.busy = false
      }
    },
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      })
    },
  },
}
</script>

<style lang="scss">

.PasswordBox {
  color: $brand-color;
  background: #EEEEEF;

  .PasswordBox__Button {
    padding: 0.75rem;
  }
  .PasswordBox__Instruction {
    font-size: 0.9rem;
  }
}

</style>
